import React, { useState } from 'react';
import { Plus } from 'react-feather';
import { Button, ActionList, Popover } from 'ui';

const TriggersHeader = ({
  newContentTrigger,
  newGroupTrigger,
  addNewTriggerFilter,
  triggerFilter,
  triggers,
}) => {
  const [newTriggersMenuOpen, setNewTriggersMenuOpen] = useState(false);
  const triggerFilterDropDown = () => {
    const triggerFilterOptions = triggers
      // eslint-disable-next-line camelcase
      .filter(({ assignee_type }) => assignee_type === 'Group')
      // eslint-disable-next-line camelcase
      .map(({ assignee_name }) => assignee_name);

    const filterValue = () => {
      if (triggerFilterOptions.includes(triggerFilter)) {
        return triggerFilter;
      }
      // To handle if a user deletes all of a filter options while viewing that filter
      addNewTriggerFilter({ target: { value: null } });
      return '';
    };
    return (
      <select
        onChange={e => {
          addNewTriggerFilter(e);
        }}
        value={filterValue()}
      >
        <option value="">{t('triggers.filter_by_group')}</option>
        {_.uniq(triggerFilterOptions).map(assigneeName => (
          <option key={assigneeName} value={assigneeName}>
            {assigneeName}
          </option>
        ))}
      </select>
    );
  };

  return (
    <div className="Triggers-header">
      <Popover
        activator={
          <Button
            className="Triggers-new-trigger-button"
            onClick={() => setNewTriggersMenuOpen(!newTriggersMenuOpen)}
          >
            <Plus className="Icon" />
            {t('triggers.new.index')}
          </Button>
        }
        visible={newTriggersMenuOpen}
        className="Triggers-new-menu"
        onClose={() => setNewTriggersMenuOpen(false)}
        onSelect={() => setNewTriggersMenuOpen(false)}
        align="right"
      >
        <ActionList
          items={[
            { content: t('triggers.new.content'), onClick: newContentTrigger },
            { content: t('triggers.new.group'), onClick: newGroupTrigger },
          ]}
        />
      </Popover>
      {triggerFilterDropDown()}
    </div>
  );
};

export default TriggersHeader;
